module.exports = __webpack_public_path__ + "media/images/flags/32/Macedonia-749e2943eef179b35bde191f0370866b.png";